module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 7-0a7adaba1728cf5d91167c69688598f6.jpg";